import 'chessboard/plugins/board-disabled/style.scss';
import { BoardDisabled } from 'chessboard/plugins/board-disabled/config/types';
import { Core } from 'chessboard/core/config/types';
import { is } from 'utils/app/model/is';
import type { Plugins } from 'chessboard/core/plugins/config/types';
import { BoardClasses } from 'chessboard/renderers/config/types';

/**
 * Create plugin to manage what happens when enabled option updates.
 */
export function createBoardDisabledPlugin(): Plugins.Model {
  return {
    create,
    match: [
      {
        condition: is(Core.OptionsEvents.Update),
        handler: handleEnabledOption,
      },
    ],
    name: BoardDisabled.Plugin.Name,
  };

  /**
   * Toggle board disabled class when plugin created
   */
  function create(ctx: Core.Context) {
    ctx.el.classList.toggle(BoardClasses.Disabled, !ctx.options.enabled);
  }

  /**
   * Toggle board disabled class when "enabled" option updates
   */
  function handleEnabledOption(event: Core.Event, ctx: Core.Context) {
    const { data: options } = event;
    const { el, renderer } = ctx;

    if ('enabled' in options) {
      el.classList.toggle(BoardClasses.Disabled, !options.enabled);
      renderer?.setBoardEnabled(options.enabled);
    }
  }
}
